import { render, staticRenderFns } from "./Goto.vue?vue&type=template&id=45bee776&scoped=true&"
import script from "./Goto.vue?vue&type=script&lang=js&"
export * from "./Goto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bee776",
  null
  
)

export default component.exports